(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["natgeo-landing"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.getElementById('ng-sticky-cta');
    var hero = document.querySelector('.ng-hero');
    if (!bar || !hero) return;
    function onScroll() {
      var heroBottom = hero.getBoundingClientRect().bottom;
      if (heroBottom < 0) bar.classList.add('visible');
      else bar.classList.remove('visible');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  (function() {
    function fireEvent(name, payload) {
      if (typeof fbq === 'function') {
        if (name === 'view_content') fbq('track', 'ViewContent', payload);
        else fbq('trackCustom', name, payload);
      }
      if (typeof gtag === 'function') gtag('event', name, payload);
      if (window.console && console.log) console.log('[track]', name, payload);
    }
    fireEvent('view_content', {
      content_name: 'NatGeo Landing Page',
      content_category: 'collection_landing'
    });
    document.querySelectorAll('[data-track="shop-collection"]').forEach(function(el) {
      el.addEventListener('click', function() {
        fireEvent('click_shop_collection', { location: el.dataset.location || 'unknown' });
      });
    });
    document.querySelectorAll('[data-track="product-card"]').forEach(function(el) {
      el.addEventListener('click', function() {
        fireEvent('click_product_card', { sku: el.dataset.sku || 'unknown' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
